/*
 * The ECG tri-bar — three green/orange/blue blocks (20×5, 3px gap) from the
 * brand lockups. A trim accent: sits under "GAMES" in the logo, or as a
 * section under-heading rule. BRAND.md: use sparingly, never as a large fill.
 */
export default function TriBar({ className = '' }: { className?: string }) {
  return (
    <span aria-hidden className={`inline-flex gap-[3px] ${className}`}>
      <span className="h-[5px] w-5 bg-ecg-green" />
      <span className="h-[5px] w-5 bg-ecg-orange" />
      <span className="h-[5px] w-5 bg-ecg-blue" />
    </span>
  );
}
